import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgBackspace = (props) => /* @__PURE__ */ _jsx("svg", {
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M15.0001 10.0001L11.0001 14.0001M11.0001 10.0001L15.0001 14.0001M7.91999 19L19.0001 19C20.1047 19 21.0001 18.1046 21.0001 17L21.0001 7C21.0001 5.89543 20.1047 5 19.0001 5L7.91999 5C7.33614 5 6.78144 5.25513 6.40148 5.69842L2.11576 10.6984C1.47378 11.4474 1.47378 12.5526 2.11576 13.3016L6.40148 18.3016C6.78144 18.7449 7.33614 19 7.91999 19Z",
		stroke: "currentColor",
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
});
export default SvgBackspace;
